import { CheckoutFlowTypeMap } from '@alto/scriptdash/alto/patient_app/checkout_flow/types/v1/checkout_flow_type';
import { type ReduxStateShared } from '~shared/types';

const getShouldShowNoNeedlesWarning = (state: ReduxStateShared) => {
  const { enterCartTypes } = state.ui.checkoutFlow;
  return Array.isArray(enterCartTypes) && enterCartTypes.includes(CheckoutFlowTypeMap.NEEDLE_PROMPT_NO_NEEDLES);
};

export default getShouldShowNoNeedlesWarning;
